import { render, staticRenderFns } from "./JcdcLoginForm.vue?vue&type=template&id=40478a22"
import script from "./JcdcLoginForm.vue?vue&type=script&lang=ts"
export * from "./JcdcLoginForm.vue?vue&type=script&lang=ts"
import style0 from "./JcdcLoginForm.vue?vue&type=style&index=0&id=40478a22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports